var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0004 17L12.9504 12.95M12.9504 12.95C13.6004 12.2999 14.116 11.5282 14.4678 10.6789C14.8196 9.82959 15.0007 8.91929 15.0007 7.99999C15.0007 7.08069 14.8196 6.17039 14.4678 5.32107C14.116 4.47175 13.6004 3.70003 12.9504 3.04999C12.3003 2.39995 11.5286 1.8843 10.6793 1.5325C9.82995 1.1807 8.91966 0.999634 8.00036 0.999634C7.08106 0.999634 6.17076 1.1807 5.32144 1.5325C4.47211 1.8843 3.7004 2.39995 3.05036 3.04999C1.73754 4.36281 1 6.14338 1 7.99999C1 9.8566 1.73754 11.6372 3.05036 12.95C4.36318 14.2628 6.14375 15.0003 8.00036 15.0003C9.85697 15.0003 11.6375 14.2628 12.9504 12.95V12.95Z",
    stroke: "#E94D51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a1510b4b5929c6d1f6666e6f871758ea.svg";
export { ForwardRef as ReactComponent };